import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=f55827c4"
import script from "./CardModal.vue?vue&type=script&lang=js"
export * from "./CardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f55827c4')) {
      api.createRecord('f55827c4', component.options)
    } else {
      api.reload('f55827c4', component.options)
    }
    module.hot.accept("./CardModal.vue?vue&type=template&id=f55827c4", function () {
      api.rerender('f55827c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/CardModal.vue"
export default component.exports